import React from "react";
import { Select } from "antd";
const { Option } = Select;

export default function SalesmanTroopsSelect({ vendedores, loading, onChange, value }) {
  return (
    <Select
      placeholder="Selecciona un vendedor"
      showSearch
      filterOption={(input, option) => {
        if (!option?.children || typeof option.children !== "string") {
          return false;
        }
        return option.children.toLowerCase().includes(input.toLowerCase());
      }}
      onChange={onChange}
      loading={loading}
      style={{ width: 300 }}
      value={value}
    >
      {vendedores.map((vendedor) => (
        <Option key={vendedor.id} value={vendedor.id}>
          {`${vendedor.first_name} ${vendedor.last_name}`}
        </Option>
      ))}
    </Select>
  );
} 